module.exports = __webpack_public_path__ + "src/components/Inbox/logo-small.jpg?9477730c";


//////////////////
// WEBPACK FOOTER
// ./src/components/Inbox/logo-small.jpg
// module id = 3100
// module chunks = 8